import { Component, Input } from '@angular/core';

@Component({
	selector: 'sn-label',
	template: require('./sn-label.html')
})
export class SnLabelComponent {
	@Input() text: string;
	@Input() color: string;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/components/common/sn-label/sn-label.ts